import Icon from 'veui/components/Icon'
import { IconPuzzlePiece } from 'dls-icons-vue'

Icon.register('puzzle-piece', IconPuzzlePiece)
